<div class="page-section">
    <div class="page-section-header">
        <h2 class="page-section-title">Instant Notification Management</h2>
        <div class="page-section-actions">
            <button class="btn btn-sm btn-outline-light" (click)="generatePairingCode()" [disabled]="loading">
                <span *ngIf="!loading">+ Register Device</span>
                <span *ngIf="loading">Generating...</span>
            </button>
            <a [href]="'/api/ww-sms.apk?company_uuid=' + company_uuid" download
                class="btn btn-sm btn-outline-light">Download App</a>
        </div>
    </div>
    <div *ngIf="pairingCode" class="d-flex justify-content-between align-items-center px-3 py-2"
        style="background: #eff6ff; border-bottom: 1px solid #bfdbfe;">
        <div>
            <span class="fw-bold" style="font-size: 12px;">New Pairing Code:</span>
            <span class="ms-2 badge bg-primary" style="font-size: 14px;">{{pairingCode}}</span>
            <div class="text-muted mt-1" style="font-size: 11px;">Expires in 15 minutes. Enter this code in the Android Gateway App.</div>
        </div>
        <button type="button" class="btn-close" style="font-size: 10px;" (click)="pairingCode = ''" aria-label="Close"></button>
    </div>
    <div class="page-section-body">
        <app-tablev2 #table></app-tablev2>
    </div>
</div>
